// var BASE_URL = "http://127.0.0.1:8489/API/";
var BASE_URL = "https://seyarkalam.naamtamilar.org:5001/API/";
// var BASE_URL = "http://192.168.0.248:8486/API/";
// var BASE_URL = "http://77.68.26.42:4849/API/";
export const environment = {
  production: false,
  hmr: false,
  API_URL: BASE_URL + "API",
  API_PARTY_POST: BASE_URL + "PartyPost/",
  API_PANCHAYATS: BASE_URL + "Panchayat",
  API_PROGRESS_BAR: BASE_URL + "getMembersSyncProgress",
  API_MEMBER_SYNC_PROGRESS: BASE_URL + "v1//Member/MembersSyncProgress",
  API_LOKSHABA_LIST: BASE_URL + "v1/Loksabha/List",
  API_CONSTITUENCY_LIST: BASE_URL + "v1/Constituency/List",
  ADD_CONSTITUENCY_API: BASE_URL + "v1/Constituency/Add",
  API_WARDS: BASE_URL + "Ward",
  API_BRANCH: BASE_URL + "Branch/",
  API_EVENT: BASE_URL + "v1/Event/OldAPI",
  ADD_BRANCH_API: BASE_URL + "v1/Branch/Add",
  API_UPDATE_BOOTH_BY_BRANCH: BASE_URL + "v1/Branch/UpdateBooth",
  GET_BRANCH_DETAILS_BY_BOOTH: BASE_URL + "v1/Branch/DetailsByBooth",

  API_EVENT_EVENTBYCONSID_FOR_REPORT:
    BASE_URL + "v1/Event/EventsByConsIdForReport",
  API_EVENT_EVENTSREPORT: BASE_URL + "v1/Event/EventsReport",
  API_EVENT_REPORT: BASE_URL + "v1/Event/OldAPI",
  API_EVENT_UPDATE_DETAILS: BASE_URL + "v1/Event/Details",
  API_EVENT_ASSOCIATE_REMOVE: BASE_URL + "v1/Event/Associate",
  API_EVENT_ASSOCIATE_EDIT: BASE_URL + "v1/Event/Associate",
  API_EVENT_ASSOCIATE_ADD: BASE_URL + "v1/Event/Associate",
  API_EVENT_ASSOCIATE_LIST: BASE_URL + "v1/Event/Associate",
  API_EVENT_TYPES: BASE_URL + "v1/Event/Types",

  API_EVENT_QUESTION: BASE_URL + "v1/Event/Question",
  API_EVENT_SUBMIT: BASE_URL + "v1/Event/Submit",
  API_EVENT_REJECT: BASE_URL + "v1/Event/Reject",
  API_EVENT_APPROVE: BASE_URL + "v1/Event/Approve",
  API_EVENT_ATTACHEMENT: BASE_URL + "v1/Event/Attachment",
  API_UPDATE_EVENT: BASE_URL + "v1/Event/Update",
  API_ADD_EVENT: BASE_URL + "v1/Event/Add",
  API_LIST_EVENT: BASE_URL + "v1/Event/GroupAndPlace",
  API_GET_EVENT: BASE_URL + "v1/Event/EventID",
  API_GET_MEDIA_EVENT: BASE_URL + "v1/Event/Media",

  API_MEMBER_LIST: BASE_URL + "v1/Member/List",
  API_MEMBER_LIST_GROUP_AND_PLACE: BASE_URL + "v1/Member/GroupAndPlaceId",
  API_SYNC_MEMBERS_WITH_REMOTE: BASE_URL + "v1/Member/SyncMembers",
  API_GET_BOOTHS: BASE_URL + "v1/Booths/getBoothsByPlaceIdAndGroupId",
  UPDATE_PARTY_POST_MEMBER_NAME: BASE_URL + "v1/Member/UpdateName",
  UPDATE_MEMBER_INFO_BY_BRANCH_PARTY_POST:
    BASE_URL + "v1/PartyPost/UpdateMemberInfoByBranchPartyPost",
  API_BOOTHS: BASE_URL + "Booths/",
  API_MEMBER: BASE_URL + "Member/",
  API_LOGIN: BASE_URL + "Login",
  API_ADDITIONAL: BASE_URL + "Additional",
  API_APPOINTMENTS: BASE_URL + "Appointments/",
  API_CHECKLIST: BASE_URL + "Checklist/",
  API_FILES: BASE_URL + "angular_files",
  GENERATE_EVENT_REPORT: BASE_URL + "download_event_report",
  DOWNLOAD_EVENT_REPORT: BASE_URL + "files/",
  API_FINANCE: BASE_URL + "Finance/",
  // GET_FINANCIAL_CLOSURE: BASE_URL + "v1/Finance/getFinancialClosure",
  GET_TOTAL_EXPENSE_AND_CONTRIBUTION:
    BASE_URL + "v1/Finance/getTotalExpenseAndContributions",
  GET_FINANCE_LIST: BASE_URL + "v1/Finance/List",
  API_ELECTION: BASE_URL + "Election/",
  API_OTHERS: BASE_URL + "Other/",
  API_NOTES: BASE_URL + "Notes/",
  API_ZONE: BASE_URL + "Zone/",
  API_ALERTS: BASE_URL + "Alerts/",
  API_OTHER: BASE_URL + "Other/",
  API_CONSTITUENCY: BASE_URL + "Constituency/",
  API_CONS_CIRCLE: BASE_URL + "ConsCircle/",
  API_VOTES: BASE_URL + "Votes/",
  API_CONTRIBUTION: BASE_URL + "Contribution/",
  // API_CONTRIBUTION_DELETE: BASE_URL + "Contribution",
  API_CONTRIBUTION_GET: BASE_URL + "v1/Contribution/List",
  API_CONTRIBUTION_FINANCE_POST: BASE_URL + "v1/Contribution",

  API_EXPENSES: BASE_URL + "Expense/",
  API_ORDERS_MATERIALS: BASE_URL + "v1/Order/GetMaterialList",
  API_ORDERS_ADDMATERIALREQ: BASE_URL + "v1/Order/AddMaterialRequirement",
  ADD_BOOTH: BASE_URL + "v1/Booths/Add",
  SPLIT_BOOTH: BASE_URL + "v1/Booths/SplitBooth",
  API_MATERIAL_REQ_LIST: BASE_URL + "v1/Order/GetMaterialRequirementList",
  API_MATERIAL_REQ_DETAILS: BASE_URL + "v1/Order/GetMaterialRequirement",
  API_MATERIAL_REQUIRMENT: BASE_URL + "v1/Order/MaterialRequirement",
  API_SUPPLIER: BASE_URL + "v1/Supplier",
  API_SUPPLIER_MATERIAL: BASE_URL + "v1/Supplier/Material",
  CORSFiles: BASE_URL + "CORSFiles",
  PUBLIC_CONTRIBUTION: BASE_URL + "Public/Contribution/",
  PUBLIC_PARTY_POST: BASE_URL + "Public/PartyPost/?fn=getPartyPostByLetterId",
  PUBLIC_DONATION: BASE_URL + "v1/Public/Donation/UpdateDonorDetails",
  PUBLIC_DONATIONDETAILS: BASE_URL + "v1/Public/Donation/UpdateDonationDetails",
  PUBLIC_GET_DONOR_DETAILS: BASE_URL + "v1/Public/Donation/GetDonorDetails",
  PUBLIC_DONATION_SEND_MAIL:
    BASE_URL + "v1/Public/Donation/SentDonationSuccessMail",
  CASHFREE_URL: "https://test.cashfree.com/billpay/checkout/post/submit",
  RETURN_URL: BASE_URL + "v1/Public/Donation/VerifyCashfreeTransaction",
  FINANCE_STATISTICS: BASE_URL + "v1/Statistics/FinanceClosure",

  MEMBERS_WITH_BRANCH_STATISTICS: BASE_URL + "v1/Statistics/MembersWithBranch",
  CONTRIBUTORS_STATISTICS: BASE_URL + "v1/Statistics/Contributors",
  ORGANAIZER_STATISTICS: BASE_URL + "v1/Statistics/Organaizer",
  BOOTH_ADMIN_STATISTICS: BASE_URL + "v1/Statistics/BoothAdmin",
  UNION_POST_STATISTICS: BASE_URL + "v1/Statistics/UnionAndTownPanchayatPosts",
  SECTION_POST_STATISTICS: BASE_URL + "v1/Statistics/SectionPosts",
  GET_RECENT_PARTY_POSTS: BASE_URL + "v1/PartyPost/GetRecentPartyPosts",
  GET_DONATION_LIST: BASE_URL + "v1/Donation/GetDonationList",
  SYNC_IPPO_PAY_INCOMPLETED_TRANSACTION:
    BASE_URL + "v1/Public/Donation/SyncIppoPayIncompleteTransaction",
  TN_ASSEMBLY_MAP:
    "http://127.0.0.1:82/tn-map-statistics/tn-map-statistics.php",
  UpdateNominationDetails: BASE_URL + "v1/Election/UpdateNominationDetails",
  UPDATE_BRANCH_NAME: BASE_URL + "v1/Branch/BranchName",
  UpdateEvmDetails: BASE_URL + "v1/Election/UpdateEvmDetails",
  Get2021CandidateBankAccountList:
    BASE_URL + "v1/Finance/Get2021CandidateBankAccountList",
  ContestDepositPaid: BASE_URL + "v1/Finance/ContestDepositPaid",
  DownloadBoothAgentLetter: BASE_URL + "v1/Booths/DownloadBoothAgentLetter",
  DownloadBoothAdminLetter: BASE_URL + "v1/Booths/DownloadBoothAdminLetter",
  GET_SURVEY_DETAIL: BASE_URL + "v1/Survey/List",
  ADD_SURVEY_ANSWER: BASE_URL + "v1/Survey/Answer",
  SUBMIT_SURVEY: BASE_URL + "v1/Survey/Submit",
  GET_ELECTION_VOTES_2021: BASE_URL + "v1/Election/ElectionVotes2021",
  ADD_ELECTION_VOTES_2021: BASE_URL + "v1/Election/AddElectionVotes2021",
  UPDATE_ELECTION_VOTES_2021: BASE_URL + "v1/Election/UpdateElectionVotes2021",
  LOGIN: BASE_URL + "v1/Auth/Login",
  GET_SURVEY_LIST: BASE_URL + "v1/Survey/List",
  GET_SURVEY_LIST_NEW: BASE_URL + "v1/Survey/SurveyList",
  API_LOGIN_HISTORY: BASE_URL + "v1/Auth/History",
  GET_ORGANIZERS: BASE_URL + "v1/Event/GetOrganizers",
  GET_CONTRIBUTORS: BASE_URL + "v1/Contribution/GetContributors",
  BLOOD_DONATION: BASE_URL + "v1/BloodDonation/BloodDonation",
  GET_SUBMITTED_LIST: BASE_URL + "v1/Survey/GetSubmittedList",
  GET_DISTRICTS: BASE_URL + "v1/District/GetDistricts",
  GET_DISTRICT_PANCHAYATS: BASE_URL + "v1/District/GetPanchayats",
  GET_DISTRICT_CONS_CIRCLE: BASE_URL + "v1/District/GetConsCircle",
  CONSTRUCT_SECTION_BY_PANCHAYAT: BASE_URL + "v1/Panchayat/ConstructSection",
  CONSTRUCT_SECTION_BY_CONS_CIRCLE: BASE_URL + "v1/ConsCircle/ConstructSection",
  CONS_CIRCLE_WARD: BASE_URL + "v1/ConsCircle/Ward",
  GET_DISTRICT_UNION_BY_DISTRICT: BASE_URL + "v1/District/DistrictUnion",
  GET_FINANCE_CLOSURE_STATISTICS_BY_DATE:
    BASE_URL + "v1/Statistics/FinanceClosureByDate",
  GET_EVENTS_BY_DATE: BASE_URL + "v1/Statistics/EventsByDate",
  GET_SUBSCRIPTION: BASE_URL + "v1/Statistics/Subscription",
  GET_FIELD_WORKERS: BASE_URL + "v1/Statistics/Fieldworkers",
  GET_PARTY_POST_BY_DATE_RANGE:
    BASE_URL + "v1/PartyPost/PartyPersonDetailsByPostDate",
  GET_PARTY_POST_COUNT: BASE_URL + "v1/PartyPost/GetPartyPostsCount",
  GET_LIST_INTENTED_PARTY_POST:
    BASE_URL + "v1/PartyPost/ListIntentedPartyPosts",
  APPROVE_PARTY_POST: BASE_URL + "v1/PartyPost/Approve",
  GET_PARTY_POST_LETTER_LIST: BASE_URL + "v1/Letters/List",
  GET_PARTY_POST_LETTER: BASE_URL + "v1/Letters/Get",
  DELETE_PARTY_POST_LETTER: BASE_URL + "v1/Letters/Delete",
  GET_PARTY_PERSON_FOR_ACTION: BASE_URL + "v1/PartyPost/PartyPersonsForAction",
  GET_PARTY_POSTS: BASE_URL + "v1/PartyPost/GetPartyPosts",
  REMOVE_PARTY_POST: BASE_URL + "v1/PartyPost/Remove",
  // GET_PARTY_POSTS: BASE_URL + "v1/PartyPost/GetPartyPosts", AssignEventId
  ASSIGN_PARTY_POST_EVENT_ID: BASE_URL + "v1/PartyPost/AssignEventId",
  REMOVE_PARTY_POST_THEERMANAM: BASE_URL + "v1/PartyPost/RemoveTheermanam",
  ASSIGN_PARTY_POST_THEERMANAM: BASE_URL + "v1/PartyPost/Theermanam",
  ADD_PARTY_POST_NOTES: BASE_URL + "v1/PartyPost/Notes",
  UPDATE_PARTY_POST_STATUS: BASE_URL + "v1/PartyPost/UpdateStatus",
  VERIFY_BRANCH_PARTY_POST: BASE_URL + "v1/PartyPost/VerifyBranchPartyPost",
  UN_VERIFY_BRANCH_PARTY_POST:
    BASE_URL + "v1/PartyPost/UnVerifyBranchPartyPost",
  GET_ALL_GROUP_APPOINTMENT_LETTERS:
    BASE_URL + "v1/PartyPost/GetAllGroupLetters",
  GENERATE_GROUP_APPOINTMENT_LETTER:
    BASE_URL + "v1/PartyPost/generateGroupLetter",
  GET_GROUP_APPOINTMENT_LETTER:
    BASE_URL + "v1/PartyPost/getAppointmentGroupLetter",
  LIST_GROUP_APPOINTMENT_LETTERS:
    BASE_URL + "v1/PartyPost/ListGroupAppointmentLetters",
  DELETE_GROUP_APPOINTMENT_LETTER:
    BASE_URL + "v1/PartyPost/DeleteGroupAppointmentLetter",
  DEACTIVE_GROUP_APPOINTMENT_LETTER:
    BASE_URL + "v1/PartyPost/DeactivateGroupAppointmentLetter",
  ACTIVE_GROUP_APPOINTMENT_LETTER:
    BASE_URL + "v1/PartyPost/ActivateGroupAppointmentLetter",
  UPDATE_LETTER_ON_PARTY_POST_IDS:
    BASE_URL + "v1/PartyPost/UpdateLetterOnPartyPostIds",
  GET_NOMINATION_STATISTICS_BY_CONSTITUENCY:
    BASE_URL + "v1/PartyPost/NominationStatisticsByConstituency",
  GET_NOMINEE_LIST_WITHOUT_BRANCH_BY_CONSTITUENCY:
    BASE_URL + "v1/PartyPost/GetNomineeListWithoutBranchByCons",

  RESET_PIN: BASE_URL + "v1/Auth/ResetPin",
  RESTRICTION: BASE_URL + "v1/PartyPost/Restriction",
  PANCHAYAT_MOVE: BASE_URL + "v1/Panchayat/Move",
  PANCHAYAT_LIST_BY_CONS_CIRCLE:
    BASE_URL + "v1/Panchayat/PanchayatByConsCircle",
  ARCHITECT_SEARCH_PLACES: BASE_URL + "v1/Architect/SearchPlaces",
  CREATE_CONS_CIRCLE: BASE_URL + "v1/ConsCircle/Create",
  RENAME_CONS_CIRCLE: BASE_URL + "v1/ConsCircle/Rename",
  GET_BRANCH_BY_SECTION: BASE_URL + "v1/Branch/List/Section",
  GET_BRANCH_BY_CONS_CIRCLE: BASE_URL + "v1/Branch/List/ConsCircle",
  GET_UNIONLIST: BASE_URL + "v1/ConsCircle/List",
  CREATE_SECTION: BASE_URL + "v1/Section/Create",
  PARTY_POST_GROUP: BASE_URL + "v1/Other/Group",
  PARTY_POST_SUBGROUP: BASE_URL + "v1/Other/SubGroup",
  UPDATE_PARTY_POST_NAME: BASE_URL + "v1/PartyPost/UpdatePostName",
  UPDATE_PARTY_POST_SUBGROUP: BASE_URL + "v1/Other/UpdateSubGroup",
  DEACTIVATE_CONS_CIRLCE: BASE_URL + "v1/ConsCircle/DeActivate",
  ADD_SURVEY: BASE_URL + "v1/Survey/AddSurvey",
  SURVEY_ALL: BASE_URL + "v1/Survey/All",
  QUESTION_GROUP_LIST: BASE_URL + "v1/Survey/QuestionGroupList",
  ADD_QUESTION_GROUP: BASE_URL + "v1/Survey/AddQuestionGroup",
  UPDATE_SURVEY: BASE_URL + "v1/Survey/Survey",
  DELETE_SURVEY: BASE_URL + "v1/Survey/Survey",
  SURVEY_TYPES: BASE_URL + "v1/Survey/Types",
  ADD_APP_QUESTIONS: BASE_URL + "v1/Survey/Question",
  APP_QUESTIONS: BASE_URL + "v1/Survey/Question",
  UPDATE_APP_QUESTIONS: BASE_URL + "v1/Survey/Question",
  DELETE_APP_QUESTIONS: BASE_URL + "v1/Survey/Question",
  UPDATE_QUESTION_GROUP: BASE_URL + "v1/Survey/QuestionGroup",
  DELETE_QUESTION_GROUP: BASE_URL + "v1/Survey/QuestionGroup",
  GET_ANSWER_OPTION: BASE_URL + "v1/Survey/Options",
  ADD_ANSWER_OPTION: BASE_URL + "v1/Survey/Options",
  UPDATE_ANSWER_OPTION: BASE_URL + "v1/Survey/Options",
  DELETE_ANSWER_OPTION: BASE_URL + "v1/Survey/Options",
  DEACTIVATE_SECTION: BASE_URL + "v1/Section/DeActivate",
  GET_SECTION_LIST: BASE_URL + "v1/Section/List",
  GET_APP_VERSION_LIST: BASE_URL + "v1/Public/App/Version",
  ADD_APP_VERSION_LIST: BASE_URL + "v1/Public/App/Version",
  UPDATE_APP_VERSION_LIST: BASE_URL + "v1/Public/App/Version",
  DELETE_APP_VERSION_LIST: BASE_URL + "v1/Public/App/Version",
  GET_AUDIENCE_LIST: BASE_URL + "v1/Survey/Audience",
  GET_GROUP_NAME: BASE_URL + "v1/PartyPost/GetPartyPublicPostGroup",
  ADD_AUDIENCE: BASE_URL + "v1/Survey/Audience",
  UPDATE_AUDIENCE: BASE_URL + "v1/Survey/Audience",
  DELETE_AUDIENCE: BASE_URL + "v1/Survey/Audience",
  ANSWERED_MEMBER_DETAIL: BASE_URL + "v1/Survey/SurveyAnswer",
  GET_SURVEY_LIST_FOR_MEMBERS: BASE_URL + "v1/Survey/SurveyListForMemebers",
  ADD_PARTY_POST_VACANCY: BASE_URL + "v1/PartyPost/PartyPostVacancies",
  DELETE_PARTY_POST_VACANCY: BASE_URL + "v1/PartyPost/PartyPostVacancies",
  GET_PARTY_POST_VACANCY_LIST: BASE_URL + "v1/PartyPost/PartyPostVacancies",
  UPDATE_PARTY_POST_VACANCY: BASE_URL + "v1/PartyPost/PartyPostVacancies",
  GET_ANSWERED_APPLICATION: BASE_URL + "v1/PartyPost/AnsweredApplications",
  GET_ADDRESS_DETAILS: BASE_URL + "v1/Address/Address",
  ADD_ADDRESS_DETAILS: BASE_URL + "v1/Address/Address",
  UPDATE_ADDRESS_DETAILS: BASE_URL + "v1/Address/Address",
  DELETE_ADDRESS_DETAILS: BASE_URL + "v1/Address/Address",
  GET_CONST_DETAILS_BY_EVENT_ID: BASE_URL + "v1/Address/AddressByEventId",
  API_CONTRIBUTION_LIST: BASE_URL + "v1/Contribution/List",
  API_CONTRIBUTION_POST: BASE_URL + "v1/Contribution/Contribution",
  API_CONTRIBUTION_UPDATE: BASE_URL + "v1/Contribution/Contribution",
  API_CONTRIBUTION_DELETE: BASE_URL + "v1/Contribution/Delete",
  API_CONTRIBUTION_RECEIPT: BASE_URL + "v1/Contribution/Receipt",

  GET_ACCESS_CONTROL_LIST: BASE_URL + "v1/Other/AccessControls",
  UPDATE_VIEW_ACCESS: BASE_URL + "v1/Other/ViewAccess",
  UPDATE_EDIT_ACCESS: BASE_URL + "v1/Other/EditAccess",
  ADD_VIEW_ACCESS: BASE_URL + "v1/Other/ViewAccess",
  ADD_EDIT_ACCESS: BASE_URL + "v1/Other/EditAccess",
  ADD_WARD: BASE_URL + "v1/Ward/Ward",
  UPDATE_WARD: BASE_URL + "v1/Ward/Ward",
  DELETE_WARD: BASE_URL + "v1/Ward/Ward",
  WARD_LIST: BASE_URL + "v1/Ward/ConsCircle",
  MEMBER_SEARCH: BASE_URL + "v1/Member/Search",
  MEMBER_bY_MEMBER_ID: BASE_URL + "v1/Member/GetMemberBasicDetails",
  GET_WARD_BY_SECTION: BASE_URL + "v1/Ward/Section",

  GET_DONATION_DETAILS: BASE_URL + "v1/Donation/GetDonationList",
  GET_SUBSCRIPTION_LIST: BASE_URL + "v1/Subscriptions/List",
  ADD_SUBSCRIPTION_LIST: BASE_URL + "v1/Subscriptions/Add",
  CANCEL_SUBSCRIPTION_LIST: BASE_URL + "v1/Subscriptions/Cancel",
  GET_SUBSCRIPTION_DETAILS: BASE_URL + "v1/Subscriptions/Details",

  LIST_DONOR_PLAN: BASE_URL + "v1/Donation/ListDonorPlan",
  ADD_DONOR_PLAN: BASE_URL + "v1/Donation/AddDonorPlan",
  UPDATE_DONOR_PLAN: BASE_URL + "v1/Donation/UpdateDonorPlan",
  DELETE_DONOR_PLAN: BASE_URL + "v1/Donation/DeleteDonorPlan",

  ADD_PARTYPOST_VACCANCIES: BASE_URL + "v1/PartyPost/AssignPost",
};
